import React, { Component } from 'react';
import './Site.css';
import { Card, Row, Col } from "reactstrap";
import Dropzone from "react-dropzone";
import Alert from "react-s-alert";
import { api } from "../helpers";

export default class DocumentUpload extends Component {
  static displayName = DocumentUpload.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
    }
  }

  render() {
    return (
      <Card>
        {/*<CardHeader className="bold-text">Documents</CardHeader>*/}
        <Row className="p-2 mt-2">
          <Col>
            <Dropzone
              accept={
                "image/*,application/pdf,.psd"
              }
              onDrop={acceptedFiles => {
                if (!acceptedFiles) {
                  Alert.warning(
                    "Document format is not accepted"
                  );
                  return;
                }

                this.setState({
                  importProcessing: true
                });
                const formData = new FormData();
                formData.append("file", acceptedFiles[0]);
                formData.append("equipmentId", this.props.equipmentId);
                api
                  .postFormData(this.props.uploadUrl, formData)
                  .then(response => {
                    if (response.data.success) {
                      Alert.success("Document was uploaded")
                      this.props.refresh();
                    } else {
                      Alert.error("An error occurred while processing upload.")
                      this.setState({
                        importProcessing: false,
                        uploadResults: null
                      });
                    }
                  })
                  .catch(error => {
                    Alert.error(
                      "There was an error processing the import data."
                    );
                    this.setState({
                      importProcessing: false
                    });
                  });
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div
                    {...getRootProps()}
                    style={{
                      backgroundColor: "#f5f5f5",
                      border: "dashed 1px #000000",
                      padding: "3em",
                      borderRadius: "5px"
                    }}
                  >
                    <input {...getInputProps()} />
                    <h5>
                      {`Drag file here to upload (or click here to
                            choose file)`}
                    </h5>
                  </div>
                </section>
              )}
            </Dropzone>
          </Col>
        </Row>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/DocumentUpload.js